window.LFApp = {
  improveDeveloperExperience: process.env.REACT_APP_IMPROVE_DEVELOPER_EXPERIENCE === 'true' && process.env.NODE_ENV === 'development',
}
